// src/lib/constants/tag.ts

/**
 * Tag constraints
 */
export const TAG_CONSTRAINTS = {
  MAX_TAGS_PER_MEDIA: 30,
  MAX_SUGGESTIONS_SHOWN: 6,
} as const;

/**
 * Characters that split pasted text into multiple tags.
 * Narrowed from legacy (which included parens/asterisks/slashes) — those
 * can appear in legitimate tags. Keeping common list separators only.
 */
export const TAG_SPLIT_CHARS = [',', ';', ':'] as const;

/**
 * Query key factory for tag-related queries
 */
export const TAG_QUERY_KEYS = {
  all: ['tag'] as const,
  list: (cId: number) => [...TAG_QUERY_KEYS.all, 'list', cId] as const,
} as const;
